import React from "react";
import { Link } from "react-router-dom";
import { servicePages } from "../data/servicePages";
import { serviceAreas } from "../data/serviceAreas";
import { homeFaq } from "../data/homeFaq";

export const LocalSeoContent = () => {
  const residentialServices = servicePages.filter((service) =>
    ["house-washing", "roof-washing", "driveway-cleaning", "gutter-cleaning", "window-cleaning"].includes(
      service.slug
    )
  );
  const commercialServices = servicePages.filter((service) =>
    ["commercial-pressure-washing", "fleet-washing"].includes(service.slug)
  );
  const topAreas = serviceAreas.slice(0, 8);

  return (
    <section id="local-seo-content">
      <div className="container">
        <div className="section-title text-center">
          <h2>Pressure Washing Services In Clinton, NC And Sampson County</h2>
          <p>
            Hamilton Pressure Washing helps homeowners, business owners, and property managers
            keep exterior surfaces clean with pressure washing, soft washing, house washing, roof
            washing, driveway cleaning, gutter cleaning, window cleaning, and commercial exterior
            cleaning in Clinton, NC and Sampson County.
          </p>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="local-seo-panel">
              <h3>Residential Pressure Washing Services</h3>
              <p>
                We use the right cleaning method for each surface, including safe soft washing for
                siding and roofs and professional surface cleaning for concrete and driveways.
              </p>
              <div className="local-seo-links">
                {residentialServices.map((service) => (
                  <Link key={service.slug} to={`/services/${service.slug}`}>
                    {service.name.toLowerCase()} in Clinton, NC
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="local-seo-panel">
              <h3>Commercial Pressure Washing Services</h3>
              <p>
                Local businesses rely on clean storefronts, sidewalks, building exteriors, and
                vehicles to make a professional first impression.
              </p>
              <div className="local-seo-links">
                {commercialServices.map((service) => (
                  <Link key={service.slug} to={`/services/${service.slug}`}>
                    {service.name.toLowerCase()} services
                  </Link>
                ))}
                <Link to="/contact">request a free commercial cleaning quote</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row local-seo-secondary-row">
          <div className="col-md-6">
            <div className="local-seo-panel">
              <h3>Why Clinton Homeowners Choose Hamilton Pressure Washing</h3>
              <p>
                Customers choose us for clear communication, careful soft washing, practical
                recommendations, and results that make homes, driveways, roofs, and exterior surfaces look cared for.
                You can review recent work in our gallery or request a free quote for your property.
              </p>
              <div className="local-seo-links">
                <Link to="/gallery">recently completed exterior cleaning work</Link>
                <Link to="/testimonials">customer testimonials</Link>
                <Link to="/contact">request a free quote</Link>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="local-seo-panel">
              <h3>Areas We Serve</h3>
              <p>
                Clinton is our primary service area. We also serve nearby Sampson County
                communities and selected surrounding towns when scheduling allows.
              </p>
              <div className="local-seo-links">
                {topAreas.map((area) => (
                  <Link key={area.slug} to={`/service-areas/${area.slug}`}>
                    pressure washing in {area.city}, {area.state}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <div className="local-seo-faq">
              <h2>Pressure Washing Questions From Clinton Homeowners</h2>
              {homeFaq.map((entry) => (
                <article key={entry.question} className="local-seo-faq-item">
                  <h3>{entry.question}</h3>
                  <p>{entry.answer}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
